import classNames from 'classnames'

import FooterListHeader from './FooterListHeader.js'
import FooterListItem from './FooterListItem.js'

import styles from '../styles/footer.module.scss'

const FooterList = ({ title, items }) => (
    <ul className={classNames(styles.footerList, 'col-sm-3')}>
        <FooterListHeader header={title} />
        {items.map((item, index) => (
            <FooterListItem key={index} {...item} />
        ))}
    </ul>
)

FooterList.propTypes = {
    title: PropTypes.string,
    items: PropTypes.array.isRequired,
}

export default FooterList
